import { COOKIE_KEYS, THEME_OPTIONS, type ThemeOption } from "@/constants";
import { clientCookie } from "@/utils/cookies";
import s from "./style.module.css";
import { handleTextSelect } from "@/utils/selection-color";
export interface Input {
    defaultTheme?: ThemeOption;
}

<const/defaultTheme=(input.defaultTheme ?? "system")>
<let/currentTheme: ThemeOption=defaultTheme>

<fieldset class=s.fieldset>
    <legend>Theme</legend>
    <for|option| of=THEME_OPTIONS>
        <div class=s.option>
            <input
                type="radio"
                id=option.value
                name="theme"
                value=option.value
                checked=option.value === currentTheme
                onChange() {
                    currentTheme = option.value;
                    document.documentElement.dataset.theme = option.value;
                    clientCookie.set(COOKIE_KEYS.THEME, option.value);
                }>
            <label for=option.value>
                ${option.label}
            </label>
            <if=option.value === "system">
                <icon-computer-20/>
            </if>
            <else-if=option.value === "dark">
                <icon-moon-20/>
            </else-if>
            <else>
                <icon-brightness-20/>
            </else>
        </div>
    </for>
</fieldset>
<script>
    handleTextSelect(currentTheme);
    document.addEventListener(
        "selectionchange",
        () => handleTextSelect(currentTheme),
        {
            signal: $signal,
        },
    );
</script>
